
import { GroupState } from "reducers/group-reducer";

export const SET_GROUP_STATE = 'SET_GROUP_STATE';

export function setGroupState(groupId: string, state: Partial<GroupState>) {
    return {
        type: SET_GROUP_STATE,
        payload: { groupId, state },
    };
}